import { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

const propTypes = {
  render: PropTypes.func.isRequired,
  companyId: PropTypes.string.isRequired,
  companyCustomizeIdArray: PropTypes.array.isRequired,
};

const defaultProps = {
  render: () => {},
  companyId: '',
  companyCustomizeIdArray: [],
};

class CompanyCustomizeProvider extends Component {
  constructor() {
    super();
    this.renderCompanyCustomize = this.renderCompanyCustomize.bind(this);
  }
  renderCompanyCustomize(renderer) {
    const {
      companyId,
      companyCustomizeIdArray,
    } = this.props;
    if (isEmpty(companyCustomizeIdArray) || companyCustomizeIdArray.indexOf(companyId) < 0) {
      return null;
    }
    return typeof renderer === 'function' && renderer();
  }

  render() {
    const { props } = this;
    const {
      render,
      companyId,
      companyCustomizeIdArray,
    } = props;
    const isCompanyCustomizeBoolean = !isEmpty(companyCustomizeIdArray) && companyCustomizeIdArray.indexOf(companyId) > -1;
    const meta = {
      renderCompanyCustomize: this.renderCompanyCustomize,
      isCompanyCustomize: isCompanyCustomizeBoolean,
    };
    return render && render(meta);
  }
}

CompanyCustomizeProvider.propTypes = propTypes;
CompanyCustomizeProvider.defaultProps = defaultProps;

export default CompanyCustomizeProvider;



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/components/CompanyCustomizeProvider/index.js
 **/